var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.params.data.title}},[_vm._v(" "+_vm._s(_vm.params.data.title)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }